import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import ApiFetch from '../data/APIFetch';

function ForumPage(){
    return (
        <> 
            <Container>
                <Row className="bg-white rounded">
                    <Col>
                        Forum Design
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ForumPage;